import { useQuery } from '@tanstack/react-query';

import type { TermsAndConditionsBrand } from '~/consts/termsAndConditions';

import { listTermsAndConditions } from '~/services/ContentService';

import { termsAndConditionsQueryKeys } from './termsAndConditionsQueryKeys';

export function useGetTermsAndConditionsList(brand: TermsAndConditionsBrand) {
  return useQuery({
    queryKey: termsAndConditionsQueryKeys.list(brand),
    queryFn: async ({ signal }) => {
      return await listTermsAndConditions(brand, { signal });
    },
    placeholderData: (previousData) => previousData,
  });
}
